import { cva, type VariantProps } from 'class-variance-authority';
import styles from './backgroundColor.module.css';
import type { InputType } from 'storybook/internal/types';

export const backgroundColorVariants = cva('', {
  variants: {
    backgroundColor: {
      transparent: styles['backgroundColor-transparent'],
      base: styles['backgroundColor-base'],
      layer1: styles['backgroundColor-layer1'],
      layer2: styles['backgroundColor-layer2'],
      layer3: styles['backgroundColor-layer3'],
      accentVibrant: styles['backgroundColor-accent-vibrant'],
      accentSubtle: styles['backgroundColor-accent-subtle'],
      accentDeep: styles['backgroundColor-accent-deep'],
      criticalVibrant: styles['backgroundColor-critical-vibrant'],
      criticalSubtle: styles['backgroundColor-critical-subtle'],
      warningVibrant: styles['backgroundColor-warning-vibrant'],
      warningSubtle: styles['backgroundColor-warning-subtle'],
      cautionVibrant: styles['backgroundColor-caution-vibrant'],
      cautionSubtle: styles['backgroundColor-caution-subtle'],
      successVibrant: styles['backgroundColor-success-vibrant'],
      successSubtle: styles['backgroundColor-success-subtle'],
      informationVibrant: styles['backgroundColor-information-vibrant'],
      informationSubtle: styles['backgroundColor-information-subtle'],
      inverseVibrant: styles['backgroundColor-inverse-vibrant'],
      inverseSubtle: styles['backgroundColor-inverse-subtle'],
      whiteVibrant: styles['backgroundColor-white-vibrant'],
      whiteSubtle: styles['backgroundColor-white-subtle'],
      disabledVibrant: styles['backgroundColor-disabled-vibrant'],
      disabledSubtle: styles['backgroundColor-disabled-subtle'],
      saleVibrant: styles['backgroundColor-sale-vibrant'],
    },
  },
  defaultVariants: {
    backgroundColor: 'transparent',
  },
});

export type BackgroundVariants = VariantProps<typeof backgroundColorVariants>;

export const backgroundColorOptions: BackgroundVariants['backgroundColor'][] = [
  'transparent',
  'base',
  'layer1',
  'layer2',
  'layer3',
  'accentVibrant',
  'accentSubtle',
  'accentDeep',
  'criticalVibrant',
  'criticalSubtle',
  'warningVibrant',
  'warningSubtle',
  'cautionVibrant',
  'cautionSubtle',
  'successVibrant',
  'successSubtle',
  'informationVibrant',
  'informationSubtle',
  'inverseVibrant',
  'inverseSubtle',
  'whiteVibrant',
  'whiteSubtle',
  'disabledVibrant',
  'disabledSubtle',
  'saleVibrant',
];

export const backgroundColorArgTypes: Record<string, InputType> = {
  backgroundColor: {
    control: 'select',
    options: backgroundColorOptions,
    description:
      'Background color of the component. Use semantic color tokens for consistent theming.',
    table: {
      type: { summary: 'BackgroundColor' },
      category: 'Background',
    },
  },
};
